/** QL-677 / QL-695 — the Mandate selection section. Read with `useT(T)`. */
export const T = {
  en_GB: {
    clear: "Clear",
    modeFixed: "Fixed weights",
    modeMinMax: "Min/max",
    save: "Save",
    selectionCleared: "Mandate selection cleared",
    selectionCurrent: "Current",
    selectionError: "Could not change the mandate selection",
    selectionNoRiskScore: "Set the goal's risk score to choose a mandate template.",
    selectionNoTemplates: "No mandate template matches the goal's risk score and platform.",
    selectionPlaceholder: "Choose a template",
    selectionSaved: "Mandate template selected",
    selectionSubtitleCustomGoal:
      "The mandate was created from the goal's portfolios. Choose a mandate template instead if one fits.",
    selectionSubtitleCustomOther:
      "The mandate was created from one of the goal's portfolios. Choose a mandate template instead if one fits.",
    selectionSubtitleCustomThis:
      "The mandate was created from this portfolio. Choose a mandate template instead if one fits.",
    selectionSubtitleExisting:
      "The portfolio is checked against the client's existing mandate. Select a mandate template to propose one that replaces it.",
    selectionSubtitleNone:
      "No mandate is set for this goal. Choose one of the mandate templates to check the portfolio against.",
    selectionSubtitleTemplate:
      "The goal's mandate is taken from the mandate templates. Change it here if another template fits better.",
    selectionSubtitleTemplateExisting:
      "A mandate template is proposed in this advice and replaces the client's existing mandate. Change it here, or go back to the existing mandate.",
    selectionTitle: "Mandate selection",
    selectionUseExisting: "Use existing mandate",
    selectionUseExistingHint: (p: { name: string; mode: string }) =>
      `${p.name} (${p.mode}) — the client's mandate at the bank`,
    selectionUseTemplate: "Select from mandate templates",
    selectionUseTemplateHint:
      "The template is proposed in this advice and replaces the client's mandate at completion.",
    selectionUsingExisting: "Using the client's existing mandate",
  },
  nb_NO: {
    clear: "Fjern",
    modeFixed: "Faste vekter",
    modeMinMax: "Min/maks",
    save: "Lagre",
    selectionCleared: "Mandatvalget er fjernet",
    selectionCurrent: "Gjeldende",
    selectionError: "Kunne ikke endre mandatvalget",
    selectionNoRiskScore: "Sett målets risikoscore for å velge en mandatmal.",
    selectionNoTemplates: "Ingen mandatmal passer målets risikoscore og plattform.",
    selectionPlaceholder: "Velg en mal",
    selectionSaved: "Mandatmal valgt",
    selectionSubtitleCustomGoal:
      "Mandatet ble opprettet fra målets porteføljer. Velg en mandatmal i stedet hvis en passer.",
    selectionSubtitleCustomOther:
      "Mandatet ble opprettet fra en av målets porteføljer. Velg en mandatmal i stedet hvis en passer.",
    selectionSubtitleCustomThis:
      "Mandatet ble opprettet fra denne porteføljen. Velg en mandatmal i stedet hvis en passer.",
    selectionSubtitleExisting:
      "Porteføljen kontrolleres mot kundens eksisterende mandat. Velg en mandatmal for å foreslå et som erstatter det.",
    selectionSubtitleNone:
      "Ingen mandat er satt for dette målet. Velg en av mandatmalene å kontrollere porteføljen mot.",
    selectionSubtitleTemplate:
      "Målets mandat er hentet fra mandatmalene. Endre det her hvis en annen mal passer bedre.",
    selectionSubtitleTemplateExisting:
      "En mandatmal er foreslått i dette rådet og erstatter kundens eksisterende mandat. Endre den her, eller gå tilbake til det eksisterende mandatet.",
    selectionTitle: "Mandatvalg",
    selectionUseExisting: "Bruk eksisterende mandat",
    selectionUseExistingHint: (p: { name: string; mode: string }) =>
      `${p.name} (${p.mode}) — kundens mandat hos banken`,
    selectionUseTemplate: "Velg fra mandatmaler",
    selectionUseTemplateHint:
      "Malen foreslås i dette rådet og erstatter kundens mandat ved fullføring.",
    selectionUsingExisting: "Bruker kundens eksisterende mandat",
  },
} as const;
